// Feature switches. Turning one off hides the module everywhere in the UI —
// the code and the backend endpoints stay in place, so flipping it back to
// true brings the whole module (and existing data) back with no other change.
export const FEATURES = {
  documents: false, // document collection: Documents queue, case Documents tab, checklist templates, doc KPIs
};
